import { useState, useEffect, useContext } from 'react'
import styles from './styles.module.css'
import { Input, Select } from '../../../components/ModalInputs'
import Button from '../../../components/Button'
import Table from '../../../components/Table'
import { StaffRosterContext } from '../../../utils/context'
import { useSelector } from 'react-redux'

const API_TAB = 'issued_documents'

// Данные для дропдаунов
const documentTypes = [
  { name: '', value: '' },
  { name: 'Справка о заработной плате', value: 'salary' },
  { name: 'Копия трудовой книжки', value: 'workbook' },
  { name: 'Справка 2-НДФЛ', value: '2ndfl' },
  { name: 'Справка о стаже', value: 'experience' },
  { name: 'Характеристика', value: 'reference' },
  { name: 'Справка для визы', value: 'visa' },
  { name: 'Справка в суд', value: 'court' },
  { name: 'Прочее', value: 'other' }
]

export default function IssuedDocuments() {
  const { allForms, trackDeletion } = useContext(StaffRosterContext)
  const { values, setFieldValue } = allForms

  // Данные из API (Redux)
  const { personTabData } = useSelector(state => state.personnel)
  const { issuedDocuments: apiIssuedDocuments } = personTabData || {}

  const [formData, setFormData] = useState({
    date: '',
    documentType: '',
    series: '',
    number: '',
    note: ''
  })

  const [selectedRow, setSelectedRow] = useState(null)

  // Данные таблицы берем из Formik
  const tableData = values.issuedDocuments || []

  // Синхронизация API данных с Formik (только при первой загрузке)
  useEffect(() => {
    if (apiIssuedDocuments && !tableData.length) {
      setFieldValue('issuedDocuments', apiIssuedDocuments)
    }
  }, [apiIssuedDocuments, tableData.length, setFieldValue])

  const handleFormChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleRowSelect = (id) => {
    setSelectedRow(selectedRow === id ? null : id)
  }

  const handleAddRow = () => {
    const newRow = {
      id: `new_${Date.now()}`,
      issue_date: formData.date,
      document_type: formData.documentType,
      series: formData.series,
      number: formData.number,
      note: formData.note
    }
    // Сохраняем в Formik
    setFieldValue('issuedDocuments', [...tableData, newRow])
  }

  const handleDeleteRow = () => {
    if (selectedRow !== null) {
      const rowToDelete = tableData.find(row => (row.id || row.xp_key) === selectedRow)
      if (rowToDelete) {
        const pk = rowToDelete.xp_key || rowToDelete.id || rowToDelete.xp_fm_id
        if (pk && !String(pk).startsWith('new_')) {
          trackDeletion(API_TAB, pk)
        }
      }
      // Обновляем в Formik
      const updatedData = tableData.filter(row => (row.id || row.xp_key) !== selectedRow)
      setFieldValue('issuedDocuments', updatedData)
      setSelectedRow(null)
    }
  }

  const renderOptions = ({ name, value }) => (
    <option key={value || 'empty'} value={value}>{name}</option>
  )

  return (
    <div className={styles.tabWrapper}>
      {/* Форма */}
      <div className={styles.qualificationForm}>
        {/* Строка 1 */}
        <div className={styles.inputsRow}>
          <Input
            label="Дата выдачи"
            type="date"
            name="date"
            value={formData.date}
            onChange={handleFormChange}
          />
          <Select
            label="Вид документа"
            name="documentType"
            value={formData.documentType}
            onChange={handleFormChange}
          >
            {documentTypes.map(renderOptions)}
          </Select>
        </div>

        {/* Строка 2 */}
        <div className={styles.inputsRow}>
          <Input
            label="Серия"
            name="series"
            value={formData.series}
            onChange={handleFormChange}
          />
          <Input
            label="Номер"
            name="number"
            value={formData.number}
            onChange={handleFormChange}
          />
        </div>

        {/* Строка 3 */}
        <div className={styles.inputsRow}>
          <Input
            label="Примечание"
            name="note"
            value={formData.note}
            onChange={handleFormChange}
          />
          <div className={styles.qualificationButtonsInline}>
            <Button onClick={handleAddRow}>+ Добавить строку</Button>
            <Button mode="delete" onClick={handleDeleteRow}>× Удалить строку</Button>
          </div>
        </div>
      </div>

      {/* Таблица */}
      <div className={styles.qualificationTableSection}>
        <Table>
          <thead>
            <tr>
              <th>Дата</th>
              <th>Вид документа</th>
              <th>Серия</th>
              <th>Номер</th>
              <th>Примечание</th>
            </tr>
          </thead>
          <tbody>
            {tableData.length > 0 ? (
              tableData.map(row => {
                const rowId = row.id || row.xp_key
                return (
                  <tr
                    key={rowId}
                    onClick={() => handleRowSelect(rowId)}
                    className={selectedRow === rowId ? styles.selectedRow : ''}
                  >
                    <td>{row.issue_date || row.date}</td>
                    <td>{row.document_type || row.documentType}</td>
                    <td>{row.series}</td>
                    <td>{row.number}</td>
                    <td>{row.note}</td>
                  </tr>
                )
              })
            ) : (
              <tr>
                <td colSpan="5" className={styles.emptyTable}>
                  Нет данных о выданных документах
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </div>
  )
}
